import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  // `keyboard` opts a tablist into roving tabindex, which only makes sense where
  // the tabs also handle arrow keys — elsewhere it would strip Tab access to them.
  static values = { default: String, keyboard: Boolean }

  connect() {
    const hash = window.location.hash.replace("#", "")
    const ownTabs = this.tabTargets.map((t) => t.dataset.tab)
    const initial = (ownTabs.includes(hash) && hash) || this.defaultValue || ownTabs[0]
    if (initial) this.show(initial)
  }

  select(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.show(tab)

    if (!this.element.closest("[data-controller='tabs'] [data-tabs-target='panel']")) {
      history.replaceState(null, "", `#${tab}`)
    }
  }

  // Arrow keys move between tabs the way a tablist is expected to, with Home and
  // End jumping to the ends. The moved-to tab takes focus so the panel it reveals
  // is the one a keyboard user is standing on.
  navigate(event) {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key]
    const lastIndex = this.tabTargets.length - 1
    let index

    if (step) {
      const current = this.tabTargets.indexOf(event.currentTarget)
      index = (current + step + this.tabTargets.length) % this.tabTargets.length
    } else if (event.key === "Home") {
      index = 0
    } else if (event.key === "End") {
      index = lastIndex
    } else {
      return
    }

    event.preventDefault()
    const tab = this.tabTargets[index]
    this.show(tab.dataset.tab)
    tab.focus()
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === name
      tab.classList.toggle("active", active)
      if (tab.getAttribute("role") === "tab") tab.setAttribute("aria-selected", active)
      if (this.keyboardValue) tab.setAttribute("tabindex", active ? "0" : "-1")
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tab !== name
    })
  }
}
